import api from '@/api/api'
import Swal from 'sweetalert2'
import { getField, updateField } from 'vuex-map-fields'

export const BOOTSTRAP = 'BOOTSTRAP'
export const SET_STATE = 'SET_STATE'
export const SET_EDIT = 'SET_EDIT'
export const LOAD_BATCH = 'LOAD_BATCH'
export const RESET_STATE = 'RESET_STATE'
export const INATIVAR_CATEGORIA = 'INATIVAR_CATEGORIA'
export const TOGGLE_CATEGORIA_STATUS = 'TOGGLE_CATEGORIA_STATUS'

const getDefaultState = () => {
  return {
    categorias: [],
    loading: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
}

const actions = {
  async [LOAD_BATCH] ({ commit, state }) {
    await api.listEntidade('categoria').then(
      categorias => {
        commit(SET_STATE, { categorias })
      },
    )
  },
  async [BOOTSTRAP] ({ dispatch, commit, state }) {
    commit(SET_STATE, { loading: true })
    await dispatch(LOAD_BATCH)
    commit(SET_STATE, { loading: false })
  },
  async [INATIVAR_CATEGORIA] ({ dispatch, commit, state }, categoria) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir essa Categoria?',
      icon: 'question',
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonColor: '#109010',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      focusConfirm: false,
      preConfirm: () => {
        return api.inativarEntidade('categoria', categoria.id).then(
          result => result,
          (error) => {
            Swal.fire({
              icon: 'warning',
              title: 'Atenção!',
              text: error.message
                ? error.message
                : 'Não foi possivel excluir a Categoria!',
            })
          },
        )
      },
    }).then(result => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'A categoria foi excluída com sucesso!',
          icon: 'success',
          showConfirmButton: false,
          timer: 2500,
        })
        dispatch(BOOTSTRAP)
      }
    })
  },
  async [TOGGLE_CATEGORIA_STATUS] ({ dispatch, state }, categoria) {
    Swal.fire({
      title: 'Atualizando o status da Categoria!',
    })
    Swal.showLoading()
    api
      .salvarEntidade(categoria, 'categoria/status', categoria.id)
      .then((response) => {
        Swal.hideLoading()
        Swal.update({
          icon: 'success',
          title: `A Categoria foi ${categoria.status == 1 ? 'ativada' : 'inativada'
            } com sucesso!`,
        })
      })
      .catch((err) => {
        console.log(err)
        Swal.hideLoading()
        Swal.update({
          icon: 'error',
          title: `Não foi possível ${categoria.status === 0 ? 'ativar' : 'inativar'
            } a Categoria!`,
        })
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
